<template>
	<div
		v-if="visible"
		class="intro"
	>
		<div
			ref="container"
			class="lottie"
		/>
		<TypographyKTypographyBody1
			class="title"
			color="#ffffff"
		>
			{{ $t('app-update') }}
		</TypographyKTypographyBody1>
	</div>
</template>

<script setup lang="ts">
	import lottie from 'lottie-web';
	import { SplashScreen } from '@capacitor/splash-screen';
	import { onMounted, ref, computed, watch, onBeforeUnmount } from 'vue'; // Явно импортируем для надежности
	import AnimationJson from '~/assets/image/system_update.json';

	const props = defineProps<{
		isUpdating?: boolean;
	}>();

	const visible = ref(true);
	const container = ref<HTMLDivElement | null>(null);

	// Убираем domLoaded, она не используется
	let animInstance: any = null;

	onMounted(async () => {
		// ОШИБКА БЫЛА ТУТ: убрал "const", иначе создавалась локальная переменная,
		// а внешняя let animInstance оставалась null (onBeforeUnmount не работал)
		animInstance = lottie.loadAnimation({
			container: container.value!,
			renderer: 'svg',
			loop: true,
			autoplay: false,
			animationData: AnimationJson
		});

		animInstance.addEventListener('DOMLoaded', async () => {
			await SplashScreen.hide();

			// Проигрываем сразу, без лишнего setTimeout
			animInstance.play();
		});
	});

	// Следим за флагом обновления

	onBeforeUnmount(() => {
		if (animInstance) {
			animInstance.destroy();
			animInstance = null;
		}
	});
</script>

<style scoped lang="scss">
	.intro {
		position: fixed;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		z-index: 999999999999;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		&::after {
			position: absolute;
			top: 0px;
			left: 0px;
			height: 100%;
			width: 100%;
			content: '';
			background-color: var(--black);
			opacity: 1;
			z-index: -1;
			opacity: 0.6;
		}

		.title {
			text-align: center;
			padding: 0px 10px;
		}
	}

	.lottie {
		width: min(250px, 100%);
		height: min(250px, 100%);
		flex-shrink: 0;
	}
</style>
